import $m from '@plugins/money';

export class Calculator {
    static $m = $m;
    get $m() {
        return $m;
    }

    constructor(properties = {}) {
        for (const key in properties) {
            if (properties[`${key}`] !== null && properties[`${key}`] !== undefined) {
                this[`${key}`] = properties[`${key}`];
            }
        }
    }

    static calculators = {};
    static registerCalculator(type, CalculatorClass) {
        this.calculators[`${type}`] = CalculatorClass;
    }

    static createCalculator(type, properties = {}) {
        const CalculatorClass = this.calculators[`${type}`];

        if (!CalculatorClass) {
            throw new Error(`Calculator type "${type}" not found`);
        }

        return new CalculatorClass(properties);
    }

    toMoney(amount = 0, fallback = 0) {
        if (isNaN(amount) || amount === null) {
            return fallback;
        }
        return { currency: this._currency, amount };
    }

    fromMoney(money, fallback = 0) {
        if (money === null) {
            return fallback;
        } else if (typeof money === 'number') {
            return money;
        } else if (typeof money === 'string') {
            return parseFloat(money);
        } else if (typeof money === 'object' && money && !isNaN(money.amount)) {
            return money.amount;
        }

        return fallback;
    }

    recalculate() {
        throw new Error('Subclasses must implement the recalculate() method');
    }
}

export default Calculator;
